export function checkBreaklistByBatch() {
    return {
        "success": true,
        "data": [
            {
                "date": "2026-04-22T00:00:00.000Z",
                "hasBreaklist": false
            }
        ]
    }
}

export function updateScheduleByBatch() {
    return {
        "success": true,
        "msg": "Schedules updated: 1 record(s) for 1 employee(s).",
        "data": {
            "updated": [
                {
                    "uid": "69854fbe6dc06900705a2108",
                    "date": "04/22/2026"
                }
            ],
            "updatedCount": 1,
            "uniqueEmployeeCount": 1,
            "failed": []
        }
    }
}



export function getBreaklistForCutoff() {
    return {
        "success": true,
        "msg": "Success",
        "data": [
            {
                "_id": "64e6deaf1a3aff002d9d7977",
                "empName": "Basilio, Renie Ver",
                "dayswork": 8,
                "hourswork": 69,
                "hourstardy": 0,
                "overtime": 0,
                "nightdiff": 0,
                "restday": 0,
                "legalholiday": 0,
                "specialholiday": 0,
                "totalLegalOtHours": 0,
                "totalSpecialOtHours": 0,
                "totalLegalRdHours": 0,
                "totalSpecialRdHours": 0,
                "totalLegalNsdHours": 0,
                "totalSpecialNsdHours": 0
            },
            {
                "_id": "6198e7cc9ab4790042035b54",
                "empName": "Domacena, Abby",
                "dayswork": 3,
                "hourswork": 49,
                "hourstardy": 3,
                "overtime": 0,
                "nightdiff": 0,
                "restday": 0,
                "legalholiday": 0,
                "specialholiday": 0,
                "totalLegalOtHours": 0,
                "totalSpecialOtHours": 0,
                "totalLegalRdHours": 0,
                "totalSpecialRdHours": 0,
                "totalLegalNsdHours": 0,
                "totalSpecialNsdHours": 0
            },
            {
                "_id": "61442a17a6566a001623bf20",
                "empName": "Pareja, Jeffrey",
                "dayswork": 8,
                "hourswork": 69,
                "hourstardy": 35,
                "overtime": 0,
                "nightdiff": 0,
                "restday": 0,
                "legalholiday": 0,
                "specialholiday": 0,
                "totalLegalOtHours": 0,
                "totalSpecialOtHours": 0,
                "totalLegalRdHours": 0,
                "totalSpecialRdHours": 0,
                "totalLegalNsdHours": 0,
                "totalSpecialNsdHours": 0
            },
            {
                "_id": "654b5265b38c77002d9cfe5b",
                "empName": "Uy, Anthony Joshua",
                "dayswork": 8,
                "hourswork": 73,
                "hourstardy": 29,
                "overtime": 0,
                "nightdiff": 0,
                "restday": 0,
                "legalholiday": 0,
                "specialholiday": 0,
                "totalLegalOtHours": 0,
                "totalSpecialOtHours": 0,
                "totalLegalRdHours": 0,
                "totalSpecialRdHours": 0,
                "totalLegalNsdHours": 0,
                "totalSpecialNsdHours": 0
            },
            {
                "_id": "61725afdcf9f680042b21d21",
                "empName": "ilagan, Darlo miguel",
                "dayswork": 9,
                "hourswork": 90,
                "hourstardy": 0,
                "overtime": 0,
                "nightdiff": 0,
                "restday": 0,
                "legalholiday": 0,
                "specialholiday": 0,
                "totalLegalOtHours": 0,
                "totalSpecialOtHours": 0,
                "totalLegalRdHours": 0,
                "totalSpecialRdHours": 0,
                "totalLegalNsdHours": 0,
                "totalSpecialNsdHours": 0
            }
        ]
    }
}


export function getBreaklistInfo() {
    return [
        {
            "_id": "64e6deaf1a3aff002d9d7977",
            "date": "2026-04-07",
            "from": "08:00",
            "to": "05:00",
            "timeIn": "07:42",
            "timeOut": "17:34",
            "hourswork": 8,
            "overtime": 0,
            "nightdiff": 0,
            "rd": 0,
            "legalholiday": 0,
            "specialholiday": 0
        },
        {
            "_id": "64e6deaf1a3aff002d9d7977",
            "date": "2026-04-08",
            "from": "08:00",
            "to": "05:00",
            "timeIn": "07:57",
            "timeOut": "17:16",
            "hourswork": 8,
            "overtime": 0,
            "nightdiff": 0,
            "rd": 0,
            "legalholiday": 0,
            "specialholiday": 0
        },
        {
            "_id": "64e6deaf1a3aff002d9d7977",
            "date": "2026-04-09",
            "from": "08:00",
            "to": "05:00",
            "timeIn": 0,
            "timeOut": 0,
            "hourswork": 0,
            "hoursTardy": 0,
            "overtime": 0,
            "nightdiff": 0,
            "rd": 0,
            "legalholiday": 0,
            "specialholiday": 0
        },
        {
            "_id": "64e6deaf1a3aff002d9d7977",
            "date": "2026-04-10",
            "from": "08:00",
            "to": "05:00",
            "timeIn": "07:03",
            "timeOut": "19:06",
            "hourswork": 10,
            "overtime": 0,
            "nightdiff": 0,
            "rd": 0,
            "legalholiday": 0,
            "specialholiday": 0
        },
        {
            "_id": "64e6deaf1a3aff002d9d7977",
            "date": "2026-04-13",
            "from": "08:00",
            "to": "05:00",
            "timeIn": "07:28",
            "timeOut": "17:00",
            "hourswork": 8,
            "overtime": 0,
            "nightdiff": 0,
            "rd": 0,
            "legalholiday": 0,
            "specialholiday": 0
        },
        {
            "_id": "64e6deaf1a3aff002d9d7977",
            "date": "2026-04-14",
            "from": "08:00",
            "to": "05:00",
            "timeIn": "07:57",
            "timeOut": "19:40",
            "hourswork": 10,
            "overtime": 0,
            "nightdiff": 0,
            "rd": 0,
            "legalholiday": 0,
            "specialholiday": 0
        },
        {
            "_id": "64e6deaf1a3aff002d9d7977",
            "date": "2026-04-15",
            "from": "08:00",
            "to": "05:00",
            "timeIn": "07:54",
            "timeOut": "17:30",
            "hourswork": 8,
            "overtime": 0,
            "nightdiff": 0,
            "rd": 0,
            "legalholiday": 0,
            "specialholiday": 0
        },
        {
            "_id": "64e6deaf1a3aff002d9d7977",
            "date": "2026-04-16",
            "from": "08:00",
            "to": "05:00",
            "timeIn": "07:40",
            "timeOut": "17:09",
            "hourswork": 8,
            "overtime": 0,
            "nightdiff": 0,
            "rd": 0,
            "legalholiday": 0,
            "specialholiday": 0
        },
        {
            "_id": "64e6deaf1a3aff002d9d7977",
            "date": "2026-04-17",
            "from": "08:00",
            "to": "05:00",
            "timeIn": "08:00",
            "timeOut": "17:25",
            "hourswork": 8,
            "hoursTardy": 0,
            "overtime": 0,
            "nightdiff": 0,
            "rd": 0,
            "legalholiday": 0,
            "specialholiday": 0
        },
        {
            "_id": "64e6deaf1a3aff002d9d7977",
            "date": "2026-04-20",
            "from": "08:00",
            "to": "05:00",
            "timeIn": "07:55",
            "timeOut": "17:35",
            "hourswork": 8,
            "overtime": 0,
            "nightdiff": 0,
            "rd": 0,
            "legalholiday": 0,
            "specialholiday": 0
        },
        {
            "_id": "64e6deaf1a3aff002d9d7977",
            "date": "2026-04-21",
            "from": "08:00",
            "to": "05:00",
            "timeIn": "08:00",
            "timeOut": "17:01",
            "hourswork": 8,
            "hoursTardy": 0,
            "overtime": 0,
            "nightdiff": 0,
            "rd": 0,
            "legalholiday": 0,
            "specialholiday": 0
        },
        {
            "_id": "64e6deaf1a3aff002d9d7977",
            "date": "2026-04-22",
            "from": "08:00",
            "to": "05:00",
            "timeIn": "07:03",
            "timeOut": "17:29",
            "hourswork": 8,
            "overtime": 0,
            "nightdiff": 0,
            "rd": 0,
            "legalholiday": 0,
            "specialholiday": 0
        }
    ]
}


export function getGeneratedBreaklists() {
    return {
        "success": true,
        "data": [
            {
                "datefrom": "2026-04-01T00:00:00.000Z",
                "dateto": "2026-04-15T00:00:00.000Z",
                "employeecount": 5,
                "approved": true,
                "cutoff": 1,
                "hasRemark": false,
                "_id": "69e1956cd2f998005777c512",
                "store": "Sparkle Star International - Inhouse mocked",
                "breaklistid": "ea381bc0-3a01-11f1-b23a-73e19d3663cf",
                "generatedby": "Sparkle Demo",
                "createdAt": "2026-04-17T02:05:32.465Z",
                "updatedAt": "2026-04-17T02:06:12.318Z",
                "__v": 0,
                "approvedby": "Sparkle Demo",
                "otpSentTo": "cbeloya@7star.com.ph"
            },

        ]
    }
}

export function getGenereatedBreaklistInfo() {
    return {
        "success": true,
        "data": [
            {
                "dayswork": 8,
                "hourswork": 69,
                "hourstardy": 0,
                "overtime": 0,
                "specialholiday": 0,
                "legalholiday": 0,
                "nightdiff": 0,
                "restday": 0,
                "totalLegalOtHours": 0,
                "totalSpecialOtHours": 0,
                "totalLegalRdHours": 0,
                "totalSpecialRdHours": 0,
                "totalLegalNsdHours": 0,
                "totalSpecialNsdHours": 0,
                "hasRemark": false,
                "_id": "69e1956cd2f998005777c513",
                "store": "Sparkle Star International - Inhouse",
                "breaklistid": "ea381bc0-3a01-11f1-b23a-73e19d3663cf",
                "employeeid": "64e6deaf1a3aff002d9d7977",
                "employeename": "Sparkle Demo",
                "createdAt": "2026-04-17T02:05:32.416Z",
                "updatedAt": "2026-04-17T02:05:32.416Z",
                "__v": 0
            },
            {
                "dayswork": 3,
                "hourswork": 49,
                "hourstardy": 3,
                "overtime": 0,
                "specialholiday": 0,
                "legalholiday": 0,
                "nightdiff": 0,
                "restday": 0,
                "totalLegalOtHours": 0,
                "totalSpecialOtHours": 0,
                "totalLegalRdHours": 0,
                "totalSpecialRdHours": 0,
                "totalLegalNsdHours": 0,
                "totalSpecialNsdHours": 0,
                "hasRemark": false,
                "_id": "69e1956cd2f998005777c514",
                "store": "Sparkle Star International - Inhouse",
                "breaklistid": "ea381bc0-3a01-11f1-b23a-73e19d3663cf",
                "employeeid": "6198e7cc9ab4790042035b54",
                "employeename": "Sparkle Demo",
                "createdAt": "2026-04-17T02:05:32.417Z",
                "updatedAt": "2026-04-17T02:05:32.417Z",
                "__v": 0
            },
            {
                "dayswork": 8,
                "hourswork": 69,
                "hourstardy": 35,
                "overtime": 0,
                "specialholiday": 0,
                "legalholiday": 0,
                "nightdiff": 0,
                "restday": 0,
                "totalLegalOtHours": 0,
                "totalSpecialOtHours": 0,
                "totalLegalRdHours": 0,
                "totalSpecialRdHours": 0,
                "totalLegalNsdHours": 0,
                "totalSpecialNsdHours": 0,
                "hasRemark": false,
                "_id": "69e1956cd2f998005777c515",
                "store": "Sparkle Star International - Inhouse",
                "breaklistid": "ea381bc0-3a01-11f1-b23a-73e19d3663cf",
                "employeeid": "61442a17a6566a001623bf20",
                "employeename": "Starjobs Demo",
                "createdAt": "2026-04-17T02:05:32.417Z",
                "updatedAt": "2026-04-17T02:05:32.417Z",
                "__v": 0
            },
            {
                "dayswork": 8,
                "hourswork": 73,
                "hourstardy": 29,
                "overtime": 0,
                "specialholiday": 0,
                "legalholiday": 0,
                "nightdiff": 0,
                "restday": 0,
                "totalLegalOtHours": 0,
                "totalSpecialOtHours": 0,
                "totalLegalRdHours": 0,
                "totalSpecialRdHours": 0,
                "totalLegalNsdHours": 0,
                "totalSpecialNsdHours": 0,
                "hasRemark": false,
                "_id": "69e1956cd2f998005777c516",
                "store": "Sparkle Star International - Inhouse",
                "breaklistid": "ea381bc0-3a01-11f1-b23a-73e19d3663cf",
                "employeeid": "654b5265b38c77002d9cfe5b",
                "employeename": "Payroll Demo",
                "createdAt": "2026-04-17T02:05:32.417Z",
                "updatedAt": "2026-04-17T02:05:32.417Z",
                "__v": 0
            },
            {
                "dayswork": 9,
                "hourswork": 90,
                "hourstardy": 0,
                "overtime": 0,
                "specialholiday": 0,
                "legalholiday": 0,
                "nightdiff": 0,
                "restday": 0,
                "totalLegalOtHours": 0,
                "totalSpecialOtHours": 0,
                "totalLegalRdHours": 0,
                "totalSpecialRdHours": 0,
                "totalLegalNsdHours": 0,
                "totalSpecialNsdHours": 0,
                "hasRemark": false,
                "_id": "69e1956cd2f998005777c517",
                "store": "Sparkle Star International - Inhouse",
                "breaklistid": "ea381bc0-3a01-11f1-b23a-73e19d3663cf",
                "employeeid": "61725afdcf9f680042b21d21",
                "employeename": "Sparkle Forms Demo",
                "createdAt": "2026-04-17T02:05:32.417Z",
                "updatedAt": "2026-04-17T02:05:32.417Z",
                "__v": 0
            }
        ]
    }
}


export function getPendingBreaklist(){
    return {
    "success": true,
    "data": [
        {
            "datefrom": "2026-04-01T00:00:00.000Z",
            "dateto": "2026-04-15T00:00:00.000Z",
            "employeecount": 5,
            "approved": true,
            "cutoff": 1,
            "hasRemark": false,
            "_id": "69e1956cd2f998005777c512",
            "store": "Sparkle Star International - Inhouse",
            "breaklistid": "ea381bc0-3a01-11f1-b23a-73e19d3663cf",
            "generatedby": "Sparkle Demo",
            "createdAt": "2026-04-17T02:05:32.465Z",
            "updatedAt": "2026-04-17T02:06:12.318Z",
            "__v": 0,
            "approvedby": "Sparkle Demo",
            "otpSentTo": "cbeloya@7star.com.ph"
        }
    ]
}
}